import { base64URLEncode, generateRandomString, sha256 } from '../../utils';

export const getCalendlyAuthUrl = async () => {
  const codeVerifier = generateRandomString(64);

  // 2. Generate challenge (SHA256 + base64url)
  const codeChallenge = base64URLEncode(await sha256(codeVerifier));

  // Store verifier in localStorage or session
  sessionStorage.setItem('calendly_verifier', codeVerifier);

  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_CALENDLY_CLIENT_ID ?? '',
    response_type: 'code',
    redirect_uri: `${window.location.origin}/callback/calendly`,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  });

  return `https://auth.calendly.com/oauth/authorize?${params.toString()}`;
};
